import { useContext, useEffect } from 'react';
import { AppModal, IconButton } from '../';
import { AppContext } from '../../providers/AppContext';
import { StyledLoginModal } from './LoginModal.styled';
import { useConnect } from 'wagmi'
import useIsMobile from '../../hooks/useIsMobile';
import { useTokenAuth } from '../../hooks';
import { sleep, convertUrl, passportInstance } from '../../utils';
import { DiscordSdkContext } from '../../providers/DiscordSdkProvider';
import { IS_STANDALONE, DISCORD_APP_ID } from '../../constants';
import { safeGtagEvent } from '../../providers/AnalyticsProvider';

const LoginTitle = () => {
  return (
    <div className='login-modal-title-holder'>
      <div className='login-modal-title-stub-short' />
      <div className='login-modal-title'>Log in with</div>
      <div className='login-modal-title-stub-long' />
      <div className='login-modal-title-question'>?</div>
      <div className='login-modal-title-stub-short' />
    </div>
  );
};

const LoginModal = () => {
  const { connectors, connect } = useConnect();
  const connector = connectors.find((c) => c.id === 'coinbaseWalletSDK');
  const isMobile = useIsMobile();
  const { login: discordTokenLogin, passportLogin: passportTokenLogin } = useTokenAuth();
  const { setDiscordToken } = useContext(DiscordSdkContext);
 
  const { browserProvider, setShowLogin, setAccountAddress, moonpaySigner, setMoonpaySigner, moonpaySdk } = useContext(AppContext);
  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data.token) {
         const token = event.data.token;
         discordTokenLogin(token);
         setShowLogin(false);
      } else if (event.data.passportAuthComplete) {
        let attempts = 10;
        while (attempts > 0) {
          const token = await passportInstance.getAccessToken();
          if (token) {
            passportTokenLogin(token);
            setShowLogin(false);
            break;
          }
          await sleep(200);
          attempts--;
	}
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const onClickPassport = async () => {
    const token = await passportInstance.getAccessToken();
    if (token) {
      passportTokenLogin(token);
      setShowLogin(false);
    } else {
      await browserProvider.send('eth_requestAccounts', []);
    }
  }

  const onClickDiscord = async () => {
    const params = {
      client_id: DISCORD_APP_ID,
      response_type: 'token',
      redirect_uri: convertUrl('/auth'),
      scope: 'identify email guilds.members.read'
    };
    safeGtagEvent('click_login_discord', {});
    const loginUrl = new URL('https://discord.com/oauth2/authorize');
    loginUrl.search = new URLSearchParams(params);
    window.open(loginUrl.toString(), '_blank', 'width=300,height=500');
  }

  return (
    <AppModal dark={true}>
      <StyledLoginModal>
        <LoginTitle />
        <div className='login-modal'>
        <div className='login-modal-moonpay-holder'>
          <div className='login-modal-question-decorator'/>
          <div className='login-modal-content'>
            <div className='login-modal-moonpay'>
	      {!IS_STANDALONE && <IconButton onClick={onClickPassport} animated={true} backgroundOverwrite='white'>
                <div className='connect-wallet-button-content'>
                  <div>IMX Passport</div>
                  <img style={{paddingBottom: '6px', width: '2rem', height: '2rem'}} src='/assets/immutable.svg'/>
                </div>
              </IconButton>}
	      <IconButton onClick={onClickDiscord} animated={true}>
                <div className='connect-wallet-button-content'>
                  <div>Discord</div>
                  <img style={{paddingBottom: '6px', width: '2rem', height: '2rem'}} src='/assets/discord.svg'/>
                </div>
              </IconButton>
            </div>
          </div>
        </div>
        </div>
      </StyledLoginModal>
    </AppModal>
  );
};

export default LoginModal;
